import moment from "moment"

export const getUTCDate = (date) => {
  return moment(date).utc().startOf("day").toISOString()
}
